import { axios } from "../../helper/axios";
import { ChargingNetworkWiseConstant } from "./ChargingNetworkWiseConstant";

const ChargingNetworkWisApi = {};

ChargingNetworkWisApi.getChargingNetworkWisApi = () => {
  return axios.get(
    ChargingNetworkWiseConstant.CHARGING_NETWORK_WISE_API + `?city=0&network=1`
  );
  
};
export { ChargingNetworkWisApi };
